import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-shadow-sm tw-shadow-slate-900/5 tw-backdrop-blur" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3" }
const _hoisted_3 = { class: "tw-p-4 tw-space-y-4" }
const _hoisted_4 = { class: "tw-overflow-x-auto" }
const _hoisted_5 = { class: "tw-min-w-full tw-text-left tw-text-sm" }
const _hoisted_6 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_7 = { class: "tw-px-3 tw-py-2 tw-align-middle" }
const _hoisted_8 = { class: "tw-px-3 tw-py-2 tw-align-middle" }
const _hoisted_9 = { class: "tw-px-3 tw-py-2 tw-align-middle" }
const _hoisted_10 = { class: "tw-px-3 tw-py-2 tw-align-middle" }
const _hoisted_11 = { class: "tw-flex tw-justify-end tw-gap-1.5" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "tw-mt-4 tw-rounded-xl tw-border tw-border-slate-200/80 tw-bg-slate-50/80 tw-p-4 tw-space-y-3"
}
const _hoisted_16 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_17 = { class: "tw-flex tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_EditableInputLabel = _resolveComponent("EditableInputLabel")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Contacts", -1)),
      (!_ctx.isEditingContact)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-white hover:tw-bg-slate-800",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startContactEdit && _ctx.startContactEdit(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "plus",
              class: "tw-mr-2 tw-h-3.5 tw-w-3.5"
            }),
            _cache[7] || (_cache[7] = _createTextVNode(" Add Contact ", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, [
              _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Name"),
              _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Phone Number"),
              _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Email"),
              _createElementVNode("th", { class: "tw-px-3 tw-py-2 tw-text-right" }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: contact.id,
                class: "hover:tw-bg-slate-50/80"
              }, [
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_EditableInputLabel, {
                    modelValue: _ctx.editingContactId === contact.id ? _ctx.editForm.name : contact.name,
                    "onUpdate:modelValue": val => _ctx.onEditFieldUpdate(contact.id, 'name', val),
                    isEditing: _ctx.editingContactId === contact.id
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "isEditing"])
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createVNode(_component_EditableInputLabel, {
                    modelValue: _ctx.editingContactId === contact.id ? _ctx.editForm.phoneNumber : contact.phoneNumber,
                    "onUpdate:modelValue": val => _ctx.onEditFieldUpdate(contact.id, 'phoneNumber', val),
                    isEditing: _ctx.editingContactId === contact.id
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "isEditing"])
                ]),
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_EditableInputLabel, {
                    modelValue: _ctx.editingContactId === contact.id ? _ctx.editForm.email : contact.email,
                    "onUpdate:modelValue": val => _ctx.onEditFieldUpdate(contact.id, 'email', val),
                    isEditing: _ctx.editingContactId === contact.id
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "isEditing"])
                ]),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.editingContactId !== String(contact.id))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-slate-100 hover:tw-text-slate-900",
                            onClick: ($event: any) => (_ctx.toggleEditContact(contact))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "pen-to-square",
                              class: "tw-h-3.5 tw-w-3.5"
                            })
                          ], 8, _hoisted_12)), [
                            [_directive_tippy, 'Edit']
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-rose-50 hover:tw-text-rose-700",
                            onClick: ($event: any) => (_ctx.deleteContact(String(contact.id)))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "trash",
                              class: "tw-h-3.5 tw-w-3.5"
                            })
                          ], 8, _hoisted_13)), [
                            [_directive_tippy, 'Delete']
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-emerald-600 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-white hover:tw-bg-emerald-700",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveContactEdit && _ctx.saveContactEdit(...args)))
                          }, " Save "),
                          _createElementVNode("button", {
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-slate-700 hover:tw-bg-slate-50",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelInlineEdit && _ctx.cancelInlineEdit(...args)))
                          }, " Cancel ")
                        ], 64))
                  ])
                ])
              ]))
            }), 128)),
            (!_ctx.contacts || _ctx.contacts.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("td", {
                    colspan: "4",
                    class: "tw-px-3 tw-py-4 tw-text-center tw-text-sm tw-text-slate-500"
                  }, " No contacts yet. ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.isEditingContact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  for: "new-contact-name",
                  class: "tw-block tw-text-xs tw-font-medium tw-text-slate-600"
                }, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "new-contact-name",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newContact.name) = $event)),
                  type: "text",
                  class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                  placeholder: "Name"
                }, null, 512), [
                  [_vModelText, _ctx.newContact.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  for: "new-contact-phone",
                  class: "tw-block tw-text-xs tw-font-medium tw-text-slate-600"
                }, "Phone number", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "new-contact-phone",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newContact.phoneNumber) = $event)),
                  type: "text",
                  class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                  placeholder: "Phone number"
                }, null, 512), [
                  [_vModelText, _ctx.newContact.phoneNumber]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  for: "new-contact-email",
                  class: "tw-block tw-text-xs tw-font-medium tw-text-slate-600"
                }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "new-contact-email",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newContact.email) = $event)),
                  type: "text",
                  class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                  placeholder: "Email"
                }, null, 512), [
                  [_vModelText, _ctx.newContact.email]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-slate-900 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveContact && _ctx.saveContact(...args)))
              }, " Save Contact "),
              _createVNode(_component_Button, {
                isGray: true,
                class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-slate-600 tw-text-white hover:tw-bg-slate-700",
                onClick: _ctx.cancelEditingContact
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}